import { createFileRoute } from "@tanstack/react-router";
import Autoutilitare from "@/pages/Autoutilitare";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/autoutilitare/")({
  head: () => routeHead("/autoutilitare/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Autoutilitare />
  );
}
